var PromiseEnv = require('../lib/promise').Promise;
var WindowEnv = require('./window');

/**
 * Adapted from https://developers.google.com/web/updates/2017/08/estimating-available-storage-space#the-present
 *
 * @returns {Promise<any>}
 *        A promise like that returned by https://developer.mozilla.org/en-US/docs/Web/API/StorageManager/estimate.
 *        Surely fulfills.
 */
exports.estimateStorage = function storageEstimateWrapper(): Promise<any> {
  var navigator = WindowEnv.getGlobal('navigator');

  try {
    return navigator.storage.estimate();
  } catch (err) {
    return PromiseEnv.resolve({usage: null, quota: null});
  }
};
